"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Download = exports.TellAFriend = exports.Communicate = exports.Privacy = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const Card = __importStar(require("../../organisms/card/card"));
const typography_1 = require("../../shared/typography");
const buttons_1 = require("../../atoms/buttons");
const styled_components_1 = __importDefault(require("styled-components"));
const input_1 = require("../../atoms/form/input");
const icons_1 = require("../../atoms/icons");
const resources_1 = require("../../resources");
const Privacy = ({ onClick, linkHref }) => {
    const { t } = (0, react_i18next_1.useTranslation)("md");
    return ((0, jsx_runtime_1.jsx)(Card.Container, { title: t("subscriptions.cards.privacy.title"), children: (0, jsx_runtime_1.jsxs)(Card.Row, { children: [(0, jsx_runtime_1.jsxs)(PrivacyWrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("subscriptions.cards.privacy.paragraphFirst") }, void 0), (0, jsx_runtime_1.jsxs)(typography_1.P, { children: [t("subscriptions.cards.privacy.paragraphMiddle"), (0, jsx_runtime_1.jsx)(typography_1.A, { href: linkHref, target: "_blank", rel: "noreferrer", children: t("subscriptions.cards.privacy.link") }, void 0), "."] }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: t("subscriptions.cards.privacy.paragraphLast") }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "secondary", onClick: onClick, children: t("subscriptions.cards.privacy.button") }, void 0)] }, void 0) }, void 0));
};
exports.Privacy = Privacy;
const PrivacyWrapper = styled_components_1.default.div `
  p {
    color: ${({ theme }) => theme.colors.greyBase};
    margin-bottom: ${({ theme }) => theme.spacings.xl};
  }

  p:last-of-type {
    margin-bottom: ${({ theme }) => theme.spacings.m};
  }

  a {
    cursor: pointer;
    font-weight: 400;
  }
`;
const Communicate = ({ onClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)("md");
    return ((0, jsx_runtime_1.jsx)(Card.Container, { title: t("subscriptions.cards.communicate.title"), children: (0, jsx_runtime_1.jsx)(Card.Row, { children: (0, jsx_runtime_1.jsxs)(CommunicateWrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("subscriptions.cards.communicate.paragraph") }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "transparent", onClick: onClick, children: t("subscriptions.cards.communicate.button") }, void 0)] }, void 0) }, void 0) }, void 0));
};
exports.Communicate = Communicate;
const CommunicateWrapper = styled_components_1.default.div `
  text-align: center;

  p {
    color: ${({ theme }) => theme.colors.greyBase};
    text-align: left;
  }

  button {
    color: ${({ theme }) => theme.colors.greyBase};
  }
`;
const mapActionToIcon = {
    whatsUp: ["fab", "whatsapp-square"],
    facebook: ["fab", "facebook-square"],
    twitter: ["fab", "twitter-square"],
    email: ["fas", "envelope-square"]
};
const renderSocialIcons = (socialActions) => {
    if (!socialActions)
        return null;
    const icons = [];
    for (const action in socialActions) {
        icons.push((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: mapActionToIcon[action], size: "lg", onClick: socialActions[action] || (() => { }) }, action));
    }
    return icons;
};
const TellAFriend = ({ code, invitations = 0, credits = 0, socialActions }) => {
    const { t } = (0, react_i18next_1.useTranslation)("md");
    const inputRef = (0, react_1.useRef)();
    const copyToClipboard = async () => {
        var _a, _b;
        if (!navigator.clipboard) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.select();
            (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.setSelectionRange(0, 99999);
            document.execCommand("copy");
            return;
        }
        await navigator.clipboard.writeText(code);
    };
    return ((0, jsx_runtime_1.jsx)(Card.Container, { title: t("subscriptions.cards.tellAFriend.title"), children: (0, jsx_runtime_1.jsx)(Card.Row, { children: (0, jsx_runtime_1.jsxs)(TellAFriendWrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("subscriptions.cards.tellAFriend.paragraph") }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("subscriptions.cards.tellAFriend.friends") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H4, { children: t("subscriptions.cards.tellAFriend.toSpend") }, void 0), (0, jsx_runtime_1.jsx)(typography_1.H2, { children: invitations }, void 0), (0, jsx_runtime_1.jsxs)(typography_1.H2, { children: ["\u20AC", `${credits},-`] }, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(input_1.Input, { value: code, disabled: true, ref: inputRef }, void 0), (0, jsx_runtime_1.jsx)(buttons_1.Button, { variant: "primary", onClick: copyToClipboard, children: t("subscriptions.cards.tellAFriend.button") }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", { children: renderSocialIcons(socialActions) }, void 0)] }, void 0) }, void 0) }, void 0));
};
exports.TellAFriend = TellAFriend;
const TellAFriendWrapper = styled_components_1.default.div `
  p {
    color: ${({ theme }) => theme.colors.greyBase};
  }

  & > div:first-of-type {
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-top: ${({ theme }) => theme.spacings.xl};
    text-align: center;

    & > h4 {
      margin-bottom: ${({ theme }) => theme.spacings.xl};
    }

    & > h2 {
      font-size: 2rem;
    }

    & > h4:first-of-type {
      order: 1;
    }

    & > h4:last-of-type {
      order: 2;
    }

    & > h2:first-of-type {
      order: 3;
    }

    & > h2:last-of-type {
      order: 4;
    }

    @media (max-width: ${({ theme }) => theme.utils.breakpoints.phone}) {
      grid-template-columns: 1fr;

      & > h4:last-of-type {
        order: 3;
      }

      & > h2:first-of-type {
        order: 2;
      }
    }
  }

  & > div:nth-of-type(2) {
    display: flex;
    margin-top: 2rem;

    & > div {
      flex: 1;
      margin-top: 0;

      & > input {
        border-color: ${({ theme }) => theme.colors.silverLighten40};
        color: ${({ theme }) => theme.colors.greyBase};
        font-weight: 500;
        max-height: 2.25rem;
        text-align: center;
      }
    }

    & > button {
      align-items: center;
      border: none;
      display: flex;
      flex: 0;
      height: 2.25rem;
      margin-left: ${({ theme }) => theme.spacings.xs};
    }
  }

  & > div:last-of-type {
    display: flex;
    justify-content: flex-end;
    margin-top: ${({ theme }) => theme.spacings.m};

    & > div {
      &:not(:last-of-type) {
        margin-right: ${({ theme }) => theme.spacings.xs};
      }
    }

    & > div:first-of-type svg {
      background-color: ${({ theme }) => theme.colors.whiteBase};
      color: #43c354;
    }

    & > div:nth-of-type(2) svg {
      background-color: ${({ theme }) => theme.colors.whiteBase};
      color: #2d88ff;
    }

    & > div:nth-of-type(3) svg {
      background-color: ${({ theme }) => theme.colors.whiteBase};
      color: #1da1f3;
    }

    & > div:last-of-type svg {
      background-color: ${({ theme }) => theme.colors.whiteBase};
      color: ${({ theme }) => theme.colors.greyBase};
    }
  }
`;
const Download = ({ onGooglePlayClick, onAppStoreClick }) => {
    const { t } = (0, react_i18next_1.useTranslation)("md");
    return ((0, jsx_runtime_1.jsx)(Card.Container, { title: t("subscriptions.cards.download.title"), children: (0, jsx_runtime_1.jsxs)(Card.Row, { children: [(0, jsx_runtime_1.jsx)(typography_1.P, { children: t("subscriptions.cards.download.paragraph") }, void 0), (0, jsx_runtime_1.jsxs)(StoresWrapper, { children: [(0, jsx_runtime_1.jsx)("div", { onClick: onGooglePlayClick, children: (0, jsx_runtime_1.jsx)(resources_1.GoogleStore, {}, void 0) }, void 0), (0, jsx_runtime_1.jsx)("div", { onClick: onAppStoreClick, children: (0, jsx_runtime_1.jsx)(resources_1.IOSStore, {}, void 0) }, void 0)] }, void 0)] }, void 0) }, void 0));
};
exports.Download = Download;
const StoresWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  width: 100%;

  img {
    cursor: pointer;
    height: auto;
    width: 162px;
  }

  img:first-of-type {
    margin-right: ${({ theme }) => theme.spacings.m};
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.phone}) {
    flex-direction: column;

    img {
      width: 100%;
      max-height: 60px;
    }

    img:first-of-type {
      margin-bottom: ${({ theme }) => theme.spacings.m};
    }
  }
`;
//# sourceMappingURL=InfoCards.js.map